// Route paths referenced from more than one module. Tab routes under the dashboard
// are derived instead — see `getDashboardTabPath` in ./dashboard.
export const LOGIN_PATH = '/login';
